// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f4eb4aa8","239":"fd8563bf","453":"b108ebf3","455":"6794de74"}[chunkId] + ".chunk.js";
};